<template>
  <div class="flex flex-col justify-start items-center">
    <h2 class="mb-8 text-center"><span>Reset Password</span></h2>

    <!-- Change Responses -->
    <p
      v-if="emailSubmitResponse && !emailSubmitResponseSuccess"
      clas="text-left w-full"
    >
      There was an error. Please reset your password again or contact the
      CareerWise team if your issue perists.
    </p>
    <p
      v-if="emailSubmitResponse && emailSubmitResponseSuccess"
      clas="text-left w-full"
    >
      Success. Your password has been updated.
    </p>

    <!-- SIGN IN INPUT -->
    <div v-if="!emailSubmitResponse" class="w-full relative">
      <div class="w-full">
        <p>New Password</p>
        <input
          id="password"
          v-model="passwordInput"
          :class="'placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600'"
          class="flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary text-black focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 mb-4"
          name="password"
          type="password"
          autocomplete="off"
          placeholder="enter your new password"
          @keyup="checkValidation"
          @change="checkValidation"
        />
      </div>
      <div class="w-full">
        <!-- TO DO - hook up password instead of email validation -->
        <p>Confirm</p>
        <div class="flex space-x-2 items-center">
          <input
            id="confirmpassword"
            v-model="confirmPasswordInput"
            :class="'placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600'"
            class="flex-grow px-4 outline-none focus:outline-none bg-transparent h-12 font-primary text-black focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 w-3/4"
            name="confirmpassword"
            type="password"
            autocomplete="off"
            placeholder="confirm your new password"
            @keyup="checkValidation"
            @change="checkValidation"
          />
          <!-- SIGN IN BUTTON -->
          <div v-if="!emailSubmitResponse" class="relative text-left">
            <button
              :disabled="!canSubmit"
              :class="[!canSubmit ? 'opacity-25' : '', thinking ? '' : '']"
              class="relative rounded-lg py-4 px-8 text-white font-primary text-center ease-in-out duration-300 h-12 bg-primary"
              @click="submitReset"
            >
              <div class="flex justify-center items-center w-full h-full">
                <div
                  class="absolute inset-0 w-full flex justify-center items-center z-20"
                >
                  <lottie v-if="thinking" :options="loadingAnimationOptions" />
                </div>
                <div
                  :class="[thinking ? 'invisible' : '']"
                  class="w-full flex items-center justify-center"
                >
                  Submit
                </div>
              </div>
            </button>
          </div>
          <!-- /SIGN IN BUTTON -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../js/mixins/shared.js'
import { EventBus } from '../../js/plugins/event-bus.js'
import * as loadingAnimation from '../components/loading.json'

export default {
  mixins: [shared],

  props: {
    token: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      canSubmit: false,
      thinking: false,
      rememberMe: 0,
      passwordInput: '',
      confirmPasswordInput: '',
      emailResetInput: '',
      signingin: false,
      emailSubmitResponse: false,
      emailSubmitResponseSuccess: false,
      resetPassword: false,
    }
  },

  watch: {
    confirmPasswordInput: {
      handler: function (val) {
        // Remove all white space from inputs...
        val = val.replace(/\s+/g, '') // or you can use your own preferred way to remove leading spaces
        this.$set(this, 'emailInput', val)
      },

      deep: true,
    },

    passwordInput: {
      handler: function (val) {
        // Remove all white space from inputs...
        val = val.replace(/\s+/g, '') // or you can use your own preferred way to remove leading spaces
        this.$set(this, 'passwordInput', val)
      },

      deep: true,
    },
  },

  mounted() {
    // When the theme changes dynamically we also need to changed stored theme data variables...
    EventBus.$on('modalAlertClose', () => {
      this.$set(this, 'emailSubmitResponse', false)
      this.$set(this, 'emailInput', '')
    })
  },

  methods: {
    noemptychars: function (event) {
      if (event.keyCode === 32) {
        event.preventDefault()
      }
    },

    // Saving animations
    // handleLoadingAnimation: function (active) {
    //   // this.loadingAnimate = active;
    // },

    // hideResetModal () {

    //     this.$set(this,'emailSubmitResponse',false);
    //     this.$set(this,'emailSubmitResponseSuccess',false);

    //     this.$set(this,'emailInput','');
    //     EventBus.$emit('toggleResetPasswordModal');

    // },

    checkValidation() {
      let canSubmit = true
      // Enable / dissable sign in button depending on the validity of the email they have provided
      if (
        this.passwordInput !== this.confirmPasswordInput &&
        this.passwordInput.length > 0
      ) {
        canSubmit = false
      }

      this.$set(this, 'canSubmit', canSubmit)
    },

    submitReset() {
      // Disable the sign in button so that we do not interupt or clog up the call...
      this.$set(this, 'signingin', true)
      this.$set(this, 'thinking', true)
      // Submit the access auth and kill the preloader...
      axios
        .post('/api/validate-password-reset', {
          password: this.passwordInput,
          token: this.token,
        })
        .then((response) => {
          this.$set(this, 'emailSubmitResponse', true)
          this.$set(this, 'signingin', false)
          this.$set(this, 'thinking', false)
          this.$set(this, 'canSubmit', true)

          let returned = response.data

          if (returned.success) {
            this.$set(this, 'emailSubmitResponseSuccess', true)
            EventBus.$emit('triggerAlertResponse', {
              status: 'success',
              message: 'Password updated',
            })
            auth.signIn(returned.access_token, returned.user, returned.expires)
            EventBus.$emit('showModal', 'reset-password')
          } else {
            EventBus.$emit('triggerAlertResponse', {
              status: 'error',
              message: 'Something went wrong!',
            })
          }
        })
    },
  },
}
</script>
